import { call, put, select, takeLatest } from 'redux-saga/effects';
import { selectServiceDataActions as actions } from '.';
import { ServiceDataResponse } from './types';
import { selectBasicForm } from 'app/features/selectedFilters/slice/selectors';

export function* fetchServiceData() {
  const { getServiceDataSuccess, getServiceDataFail } = actions;
  const basicForm = yield select(state => selectBasicForm(state, 2));

  try {
    let selectServiceResponse;

    if (basicForm === 'pneumatic_actuator') {
      selectServiceResponse = yield call(
        fetch,
        `/valve-configurator/api/pneumaticservices`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    } else if (basicForm === 'gearbox') {
      selectServiceResponse = yield call(
        fetch,
        `/valve-configurator/api/gearboxes`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    } else {
      selectServiceResponse = yield call(
        fetch,
        `/valve-configurator/api/electricservices`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    }

    if (selectServiceResponse.status !== 200) {
      return yield put(getServiceDataFail('Failed to fetch'));
    } else {
      const selectServiceData: ServiceDataResponse =
        yield selectServiceResponse.json();

      if (!selectServiceData) {
        return yield put(getServiceDataFail('NO DATA'));
      } else {
        return yield put(getServiceDataSuccess(selectServiceData));
      }
    }
  } catch (e) {
    yield put(getServiceDataFail(e));
  }
}
export function* selectServiceSaga() {
  yield takeLatest(actions.getServiceData.type, fetchServiceData);
}
